// extracted by mini-css-extract-plugin
export default {"thumb":"_-6A16"};